export default function safe(object, ...keys) {
  return keys.reduce((object, key) => object ? object[ key ] : object, object)
}
